<template>
  <div class="white-container full-page-container common-table">
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="nickname" label="会员昵称" />
      <el-table-column label="跑步时长">
        <template v-slot="{row}">
          {{ formatDuration(row.runningDuration) }}
        </template>
      </el-table-column>
      <el-table-column prop="averagePaceTime" label="平均配速" />
      <el-table-column label="跑步距离">
        <template v-slot="{row}">
          {{ formatDistance(row.runningDistance) }}
        </template>
      </el-table-column>
      <el-table-column label="跑步轨迹图" width="180">
        <template v-slot="{row}">
          <div v-if="row.roadMapImageUrl" class="graph-thumb">
            <el-image style="width: 165px; height: 165px" fit="cover" :src="row.roadMapImageUrl" :preview-src-list="[row.roadMapImageUrl]" />
            <span class="graph-thumb-overlay">查看图片</span>
          </div>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="跑步开始时间">
        <template v-slot="{row}">
          {{ row.runningBeginTime ? $moment(row.runningBeginTime).format('YYYY/MM/DD HH:mm:ss') : '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="memberId" label="Member ID" />
      <el-table-column label="是否异常">
        <template v-slot="{row}">
          <el-tag :type="row.status === 0 ? 'success' : 'danger'" size="mini">{{ row.status === 0 ? '正常' : '异常' }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="fixed-below"
      :page-size="currentPage.limit"
      :page-sizes="[10, 20, 50, 100]"
      :current-page.sync="currentPage.current"
      :total="currentPage.total"
      layout="total, prev, pager, next, sizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      activityId: null,
      list: [],
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  created() {
    this.activityId = Number(this.$route.query.id);
    this.getList();
  },
  methods: {
    getList() {
      this.$Api.running.getGraphImg({
        current: this.currentPage.current,
        limit: this.currentPage.limit,
        activityId: this.activityId,
      }).then(res => {
        if (res) {
          console.log("//*//*/**", res);
          this.list = res.data;
          this.currentPage.total = res.total;
        }
      });
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },
    formatDuration(seconds) {
      if (seconds == null) return '--';
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = seconds % 60;
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    },
    formatDistance(meters) {
      if (meters == null) return '--';
      return `${(meters / 1000).toFixed(2)} km`;
    },
  },
};
</script>
<style lang="less" scoped>
.graph-thumb {
  position: relative;
  display: inline-block;
  width: 165px;
  height: 165px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;

  .graph-thumb-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
  }

  &:hover .graph-thumb-overlay {
    opacity: 1;
  }
}
</style>
<style lang="less">
.el-image-viewer__wrapper .el-image-viewer__close {
  top: auto;
  bottom: 5%;
  right: 50%;
  transform: translateX(50%);
  color: #fff;
  font-size: 28px;
}

.el-image-viewer__wrapper .el-image-viewer__actions {
  display: none;
}
</style>
